import type { Prefs } from '../types/book';

export type NativeDebugRoute = {
  bookId: string | null;
  flow: 'scrolled' | 'paginated' | null;
  path: string;
  theme: Prefs['theme'] | null;
  nativeImmersiveMode: boolean | null;
};

const normalizePath = (value: string): string => {
  if (!value) {
    return '/';
  }

  return value.startsWith('/') ? value : `/${value}`;
};

const parseBooleanFlag = (value: string | null): boolean | null => {
  if (value === null) {
    return null;
  }

  if (value === 'true' || value === '1') {
    return true;
  }

  if (value === 'false' || value === '0') {
    return false;
  }

  return null;
};

const parseTheme = (value: string | null): Prefs['theme'] | null => {
  if (value === 'light' || value === 'dark' || value === 'auto') {
    return value;
  }

  return null;
};

const parseFlow = (value: string | null): NativeDebugRoute['flow'] => {
  if (value === 'scrolled' || value === 'paginated') {
    return value;
  }

  return null;
};

const deriveBookIdFromPath = (path: string): string | null => {
  const segments = path.split('/').filter(Boolean);
  if (segments[0] !== 'read' || !segments[1]) {
    return null;
  }

  return segments[1];
};

export const parseNativeDebugUrl = (rawUrl: string): NativeDebugRoute | null => {
  let parsedUrl: URL;
  try {
    parsedUrl = new URL(rawUrl);
  } catch {
    return null;
  }

  if (parsedUrl.protocol !== 'wereader:' || parsedUrl.hostname !== 'debug') {
    return null;
  }

  const path = normalizePath(parsedUrl.searchParams.get('path')?.trim() || '/');
  const bookId = parsedUrl.searchParams.get('bookId')?.trim() || deriveBookIdFromPath(path);

  return {
    bookId: bookId || null,
    flow: parseFlow(parsedUrl.searchParams.get('flow')),
    path,
    theme: parseTheme(parsedUrl.searchParams.get('theme')),
    nativeImmersiveMode: parseBooleanFlag(parsedUrl.searchParams.get('immersive')),
  };
};
